import React, {useState,useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Button} from '@components';
import ActivityTab from './ActivityTab';
import TimelineTab from './TimelineTab';
import SettingsTab from './SettingsTab';
import {nhanvienService} from "@app/services/nhanvienService";
import {useSelector} from "react-redux";

const Profile = () => {
    const [activeTab, setActiveTab] = useState('INFORMATION');
    const [t] = useTranslation();
    let user = useSelector((state) => state.auth.currentUser);

    let userTmp = localStorage.getItem("profile");
    if(userTmp)
        user = JSON.parse(userTmp);


    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    const initialNhanvien = {
        id: 0,
        dangnhap: '',
        ten: '',
        matkhau: '',
        dienthoai: '',
        diachi: '',
        email: '',
        trangthai: 1,
        loaifk: 3,
        quyenId: -1,
        nppIds:[],
        tenLoaiNhanVien: '',
        listKhoa:[]
    };
    const [nhanvien, setNhanvien] = useState(user);
    const [loading, setLoading] = useState(false);
    

    useEffect(async () => {
       /* setLoading(true);
        nhanvienService.getCurrentUser().then((response) => {
            //console.log('getById', JSON.stringify(response, null, 2));
            const userX = response.data.data;

            setNhanvien(userX);

        });


        setLoading(false);*/

    }, []);

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('header.user.profile')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('header.label.home')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('views.user.profile')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card card-primary card-outline">
                                <div className="card-body box-profile">
                                    <div className="text-center">
                                        <img
                                            className="profile-user-img img-fluid img-circle"
                                            src={nhanvien.anhdaidien}
                                            alt="User profile"
                                        />
                                    </div>
                                    <h3 className="profile-username text-center">
                                        {nhanvien.name}
                                    </h3>
                                    <p className="text-muted text-center">
                                        {nhanvien.username}
                                        {/*{JSON.stringify(nhanvien.role, null, 2)}*/}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="card">
                                <div className="card-header p-2">
                                    <ul className="nav nav-pills">
                                        <li className="nav-item">
                                             <button
                                                type="button"
                                                className={`nav-link ${
                                                    activeTab === 'INFORMATION'
                                                        ? 'active'
                                                        : ''
                                                }`}
                                                onClick={() =>
                                                    toggle('INFORMATION')
                                                }
                                            >
                                                {t('main.label.settings')}
                                            </button>
                                            {/*<a className={`nav-link ${
                                                activeTab === 'INFORMATION'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                               onClick={() =>
                                                   toggle('INFORMATION')
                                               }
                                               data-toggle="tab"
                                               href="#"
                                            >
                                                {t('main.label.settings')}
                                            </a>*/}
                                        </li>
                                        <li className="nav-item">
                                             <button
                                                type="button"
                                                className={`nav-link ${
                                                    activeTab === 'ACTIVITY'
                                                        ? 'active'
                                                        : ''
                                                }`}
                                                onClick={() =>
                                                    toggle('ACTIVITY')
                                                }
                                            >
                                                {t('recover.changePassword')}
                                            </button>
                                            {/*<a className={`nav-link ${
                                                activeTab === 'ACTIVITY'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                               onClick={() =>
                                                   toggle('ACTIVITY')
                                               }
                                               data-toggle="tab"
                                               href="#"
                                            >
                                                {t('recover.changePassword')}
                                            </a>*/}
                                        </li>
                                    </ul>
                                </div>
                                <div className="card-body">
                                    <div className="tab-content">
                                        {/*
                                        <TimelineTab
                                            isActive={activeTab === 'TIMELINE'}
                                        />*/}
                                        <SettingsTab
                                            isActive={activeTab === 'INFORMATION'}
                                        />
                                        <ActivityTab
                                            isActive={activeTab === 'ACTIVITY'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Profile;
